import React from 'react';

// @mui
import {
    TableCell,
} from '@mui/material';
import config from '../../config';
import i18n from 'i18';
import { isValidJSON } from '../../utils/formatName';

export default class GridSelectCell extends React.Component {

    render() {
        // props: value, id, field
        const { value, field } = this.props;
        const display = field.display;
        const fallbackDisplay = field.fallbackDisplay;
        const enumType = field?.enumType;
        let displayValue = "";
        // displayValue is the value from the object that will be displayed in the cell
        if (value) {
            if (display) {
                if (isValidJSON(value[display])) {
                    let parseValue = JSON.parse(value[display]);
                    displayValue = parseValue[config.language];
                } else {
                    let parts = display.split("+");
                    displayValue = parts.map(part => value[part]).join(" ");
                    if (enumType) {
                        displayValue = i18n.t(`enums.${displayValue}`);
                    }
                }
            } else {
                if (fallbackDisplay) {
                    displayValue = value[fallbackDisplay];
                }
                displayValue = "ID: " + value.id;
            }
        }

        return (<TableCell align="left">{displayValue}</TableCell>);
    }

}
